import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import {filter} from 'rxjs/operators';
import {Observable} from 'rxjs/Observable';

@Component({
  selector: 'app-nav-bar',
  templateUrl: './nav-bar.component.html',
  styleUrls: ['./nav-bar.component.scss'],
  encapsulation : ViewEncapsulation.None // conflict with bootstrap
})
export class NavBarComponent implements OnInit {

  includedRoute = [
    '/home',
    '/library',
    '/account',
    '/login'
  ];

  activeRoute = '';

  constructor(private router: Router) { }

  ngOnInit() {
    this.router.events
      .pipe(filter((e) => e instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.setActive(event.url);
      });

    this.setActive(this.router.url);
  }

  setActive(url: string) {
    if (this.includedRoute.findIndex((x) => x === url) !== -1) {
      this.activeRoute = url;
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/nav-bar/nav-bar.component.ts